<p>
  To protect against fraud, winnings are not available to be withdrawn until 72 hours after the funds were won.
</p>
